import React, { Component } from "react";
import "./register.css"
import Logo from "../../asset/images/Logo1.png"
import { Link } from "react-router-dom";
import Image from "../../asset/images/image1.jpeg"

class ForgottenPassword extends Component {
    render() {
        return (
            <div className="registration_container">


                <section className="registration image">
                    <div className="style"></div>
                    <div className="style"></div>
                    <img src={Image} alt="register_image"/>
                </section>




                <section className="registration content">

                    <header className="register_header">
                        <Link to="/"><img src={Logo} alt="logo" /></Link>
                    </header>


                    <div className="register_body">
                        <h2>Reset Your Access</h2>
                        <p>Securely recover your account and get back on track</p>
                        {/* <button className="google">Sign Up With Google</button>
                        <p>--- or ---</p> */}
                        <form>
                            <input placeholder="Email" required />
                            {/* <input placeholder="Paswword" required /> */}
                            {/* <p><Link to="/forgotten_password"><span>Forgotten password</span></Link></p> */}
                            <button> Submit </button>

                        </form>
                        {/* <p>New to GeoGIS? <Link to="/signup"><span className="blue">Join Us</span></Link></p> */}

                    </div>


                    <footer className="register_footer">

                    </footer>



                </section>
                
            </div>
        )
    }
}



export default ForgottenPassword